import { createSelector } from 'reselect';

export const selectHybridSearchResults = state => state.hybridSearchResults;

// Merchants fetched by GSP ids
export const selectHybridStores = createSelector(
  selectHybridSearchResults,
  hybridSearchResults => hybridSearchResults.hybridStores,
);

export const selectHybridStoresConfig = createSelector(selectHybridStores, ({ config }) => config);
export const selectHybridStoresMerchants = createSelector(selectHybridStores, ({ merchants }) => merchants);
export const selectHybridStoresIsLoaded = createSelector(selectHybridStores, ({ isLoaded }) => isLoaded);
export const selectHybridStoresIsLoading = createSelector(selectHybridStores, ({ isLoading }) => isLoading);
export const selectHybridStoreMerchantById = createSelector(
  [selectHybridStoresMerchants, (state, id) => id],
  (merchants, id) => merchants.find(merchant => merchant.id === Number(id)),
);
